import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Award, Sparkles, CheckCircle2 } from 'lucide-react';
export function ProgramsPricing() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2895">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2896">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-2897">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-2898">
            Affordable Pricing
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-2899">
            Simple ways to get started at Storm Taekwondo — pick what works best
            for your family.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-start max-w-6xl mx-auto" data-id="element-2900">
          {/* Left: Features */}
          <div className="flex flex-col gap-6" data-id="element-2901">
            {[{
            icon: Calendar,
            title: 'Flexible Schedule',
            copy: 'Choose the perfect class time for your child at Storm Taekwondo.'
          }, {
            icon: Award,
            title: 'Expert Instructors',
            copy: 'Attend classes led by experienced and certified Taekwondo coaches.'
          }, {
            icon: Sparkles,
            title: 'Fun and Engaging',
            copy: 'Lessons are high-energy and structured so students stay motivated and keep growing.'
          }].map(({
            icon: Icon,
            title,
            copy
          }) => <div key={title} className="flex items-start gap-4 bg-off-white rounded-2xl border border-subtle-gray p-6" data-id="element-2902">
                <div className="w-12 h-12 bg-storm-red/10 text-storm-red rounded-xl flex items-center justify-center shrink-0" data-id="element-2903">
                  <Icon className="w-6 h-6" data-id="element-2904" />
                </div>
                <div data-id="element-2905">
                  <h3 className="text-xl text-ink mb-1.5" data-id="element-2906">{title}</h3>
                  <p className="text-gray-warm leading-relaxed" data-id="element-2907">{copy}</p>
                </div>
              </div>)}
          </div>

          {/* Right: Pricing card */}
          <div className="bg-off-white rounded-2xl border-2 border-storm-red shadow-xl p-8 lg:p-10 relative" data-id="element-2908">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-storm-red text-white px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wide whitespace-nowrap" data-id="element-2909">
              Get Started
            </div>

            <h3 className="font-display text-3xl md:text-4xl text-storm-red leading-tight mb-2 mt-2" data-id="element-2910">
              FREE ONE WEEK TRIAL
            </h3>
            <p className="text-lg text-storm-red font-bold mb-8" data-id="element-2911">
              OR full month trial only $99 — includes uniform.
            </p>

            <div className="pt-6 border-t border-subtle-gray" data-id="element-2912">
              <p className="font-bold text-ink uppercase tracking-wide mb-4" data-id="element-2913">
                Includes:
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-2914">
                {['Belt Progression', 'Character Development', 'Weekly Classes', 'Goal Setting', 'Personalized Instruction', 'Confidence Building', 'Fitness and Conditioning', 'Friendship and Teamwork', 'Self-Defense Techniques', 'Competition Preparation'].map(item => <li key={item} className="flex items-start gap-2 text-gray-warm" data-id="element-2915">
                    <CheckCircle2 className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-2916" />
                    <span data-id="element-2917">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-2918">
              <Link to="/SignMeUp" className="btn-primary text-center flex-1" data-id="element-2919">
                Start With a Trial Class
              </Link>
              <Link to="/ContactUs.html" className="btn-secondary text-center flex-1" data-id="element-2920">
                Ask a Question
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}